export interface FilterStorageData {
  [key: string]: any;
  timestamp?: number;
}

export interface UseFilterStorageParams {
  storageKey: string;
}

export interface UseFilterStorageReturn {
  getStoredFilters: () => FilterStorageData | null;
  setStoredFilters: (_filterData: Partial<FilterStorageData>) => void;
  hasLocalStoredFilters: () => boolean;
  clearStoredFilters: () => void;
}

export const useFilterStorage = ({
  storageKey,
}: UseFilterStorageParams): UseFilterStorageReturn => {
  const getStoredFilters = (): FilterStorageData | null => {
    try {
      const key = storageKey;
      const stored = localStorage.getItem(key);
      return stored ? JSON.parse(stored) : null;
    } catch (error) {
      console.error('Error getting stored filters:', error);
      return null;
    }
  };

  const setStoredFilters = (filterData: Partial<FilterStorageData>): void => {
    const key = storageKey;
    const storedFilters = getStoredFilters();
    const dataToStore: FilterStorageData = {
      ...storedFilters,
      ...filterData,
      timestamp: Date.now(),
    };
    localStorage.setItem(key, JSON.stringify(dataToStore));
  };

  const hasLocalStoredFilters = (): boolean => {
    const storedFilters = getStoredFilters();
    return storedFilters && Object.keys(storedFilters).length > 0;
  };

  const clearStoredFilters = (): void => {
    const key = storageKey;
    localStorage.removeItem(key);
  };

  return {
    getStoredFilters,
    setStoredFilters,
    hasLocalStoredFilters,
    clearStoredFilters,
  };
};
